var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"star"},React.createElement("path",{"id":"Icon","d":"M22.2858 3.43431L27.8649 13.662L40.3413 15.3122L31.3136 23.2688L33.4441 34.5095L22.2858 29.1996L11.1274 34.5095L13.258 23.2688L4.23022 15.3122L16.7066 13.662L22.2858 3.43431Z","fill":"#EEA077"})));
}

Star.defaultProps = {"width":"44","height":"40","viewBox":"0 0 44 40","fill":"none"};

module.exports = Star;

Star.default = Star;
